import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function RegionPageHeader({ onCreateClick }) {
  const [t] = useTranslation();

  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold">{t("admin.regions")}</h1>
      <Button
        Icon={PlusIcon}
        text={t("admin.create_region")}
        onClick={onCreateClick}
        color="primary"
      />
    </div>
  );
}

